"use client"

import type React from "react"
import { createContext, useEffect, useState } from "react"

export const UserContext = createContext<{
  isInternal: boolean
}>({
  isInternal: false,
})

export function UserContextProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [isInternal, setIsInternal] = useState(false)

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.metaKey && e.shiftKey && e.key === "I") {
        setIsInternal(() => !isInternal)
      }
    }

    window.addEventListener("keydown", handler)

    return () => {
      window.removeEventListener("keydown", handler)
    }
  })

  return (
    <UserContext.Provider value={{ isInternal: isInternal }}>
      {children}
    </UserContext.Provider>
  )
}
